import { timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
export var locationSectorNameUniqueAsyncValidator = function (_a) {
    var locationSectorApi = _a.locationSectorApi, locationId = _a.locationId, sectorId = _a.sectorId;
    return function (control) {
        var name = control.value;
        return timer(500)
            .pipe(switchMap(function () { return locationSectorApi.search({
            where: {
                nameEq: name,
                locationId: locationId
            },
            limit: 1,
            offset: 0,
        }); }), map(function (_a) {
            var items = _a.items;
            return items.some(function (item) { return item.id !== sectorId; })
                ? { nameAlreadyExists: true }
                : null;
        }));
    };
};
